export default class MarketPartModal {
	static init() {
		this.initSearchButton();
	}

	static initSearchButton() {
		const openButtons = document.querySelectorAll("[data-open-market-part]");
		const partModal = document.querySelector(".market-part-modal");

		if (!partModal) {
			return;
		}

		const marketName = partModal.querySelector(".market-name");
		const tags = partModal.querySelectorAll(".tags.main-parts .tag");
		openButtons.forEach(button => {
			button.addEventListener("click", () => {
				if (partModal.classList.contains("active")) {
					partModal.classList.remove("active");
				} else {
					partModal.classList.add("active");
					marketName.innerText = " " + button.dataset.marketName;
					const partsString = button.dataset.marketMainParts;
					const parts = partsString.split(",");
					tags.forEach(tag => {
						if (parts.includes(tag.dataset.partSlug)) {
							tag.classList.remove("d-none");
						} else {
							tag.classList.add("d-none");
						}
					});
				}
			});
		});

		partModal.addEventListener('click', function (e) {
			if (e.target !== this) {
				return;
			}
			partModal.classList.remove('active');
		});
	}
}
